import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getSliderTestIds = createTestIds('slider', ['control', ...elements] as const);
